'use client';

import { useCallback, useMemo } from 'react';
import { parseAsInteger, useQueryState } from 'nuqs';
import {
  EntryListQuery,
  EntryListSort,
  paramsSortToQuerySort,
  querySortToParamsSort,
  sortTabToQuerySort,
} from '@/features/EntryList/searchParams';

export const useListFilterParams = (
  queryFilter: Partial<EntryListQuery['filter']>,
  queryInitialSort: EntryListSort = EntryListSort.Ending,
  queryLimit = 40
) => {
  const [querySort, setQuerySort] = useQueryState('jarjestys', {
    parse: (value) => paramsSortToQuerySort[value] ?? null,
    serialize: (value) => querySortToParamsSort[value],
    shallow: false,
  });

  const [queryPage, setQueryPage] = useQueryState('sivu', { ...parseAsInteger, shallow: false });

  const onSortChange = useCallback(
    (index: number) => {
      void setQuerySort(sortTabToQuerySort[index]);
      void setQueryPage(1);
    },
    [setQuerySort, setQueryPage]
  );

  const query = useMemo(
    () =>
      ({
        filter: queryFilter,
        page: queryPage ?? 1,
        sort: querySort ?? queryInitialSort,
        limit: queryLimit,
      }) as EntryListQuery,
    [queryFilter, queryInitialSort, queryLimit, queryPage, querySort]
  );

  return {
    query,
    onSortChange,
    setQueryPage,
  };
};
